import { MONTHLY } from 'self-service-api/constants/Terms';
export const COMPARE_HEADER = 'compare-header';
export const DISCOUNTED = 'discounted';
export const NEW_CUSTOMER_OFFER = 'new-customer-offer';
export const PROMOTION = 'promotion';
export const SUITE_INTERSTITIAL = 'suite-interstitial';
export const HERO_BANNER_CONTENT = 'hero-banner-content';
export const PRICE_DISPLAY_KEY_GETTER = {
  [COMPARE_HEADER]: () => 'startsAtBold_jsx',
  [HERO_BANNER_CONTENT]: () => 'startsAtBold_jsx',
  [DISCOUNTED]: term => {
    return term === MONTHLY ? 'discountedPricingPerMonthBilledMonthly_jsx' : 'discountedPricingPerYearAtCost_jsx';
  },
  [NEW_CUSTOMER_OFFER]: term => {
    return term === MONTHLY ? 'newCustomerOfferPricingPerMonthBilledMonthly_jsx' : undefined;
  },
  [PROMOTION]: term => {
    return term === MONTHLY ? 'promotionPricingPerMonthBilledMonthly_jsx' : 'promotionPricingPerYearAtCost_jsx';
  },
  [SUITE_INTERSTITIAL]: () => 'startsAtBold_jsx'
};